import { Flex } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { MEDICAL_HISTORY } from 'src/enums';
import {
  REACT_APP_HOSPITAL_CODE,
  USER_ACTIVITY_EVENT,
  USER_ACTIVITY_TYPE
} from 'src/enums';
import NoMatch from 'src/screens/noMatch/NoMatchScreen';
import { documentsSelectors, userSelectors } from 'src/store';
import { IDocument } from 'src/types/documents.types';
import { createLog, onClickDownloadPdf } from 'src/utils';

import DocumentCard from '../documentCard';
import classes from './style/DocumentsList.module.css';

interface IDocumentsListProps {
  exa?: string;
  activeKey?: MEDICAL_HISTORY;

  list: IDocument[];
}

const DocumentsList: React.FunctionComponent<IDocumentsListProps> = (props) => {
  const { t } = useTranslation();
  const { activeKey, list } = props;

  const dispatch = useDispatch();
  const allDocuments = useSelector(documentsSelectors.selectDocumentsData);
  const user = useSelector(userSelectors.selectUser);

  useEffect(() => {
    createLog(
      user,
      USER_ACTIVITY_EVENT.VIEW,
      USER_ACTIVITY_TYPE.SCREEN,
      activeKey || ''
    );
  }, [allDocuments, activeKey]);

  const onClickPdf = async (item: IDocument) => {
    if (!user || !REACT_APP_HOSPITAL_CODE) {
      console.error('User or hospital code is missing');
      return;
    }

    try {
      await onClickDownloadPdf(item, dispatch);
      createLog(
        user,
        USER_ACTIVITY_EVENT.VIEW,
        USER_ACTIVITY_TYPE.PDF,
        activeKey || ''
      );
    } catch (error) {
      console.error('Error downloading PDF:', error);
    }
  };

  const renderList = () => {
    return list.map((doc, i) => {
      return <DocumentCard key={i} doc={doc} downloadDocument={onClickPdf} />;
    });
  };

  const renderView = () => {
    if (list.length === 0) {
      return <NoMatch />;
    }
    return <div className={`${classes.mainContainer}`}>{renderList()}</div>;
  };

  return (
    <Flex vertical className={classes.mainFlex}>
      {renderView()}
    </Flex>
  );
};

export default DocumentsList;
